
const currentConfig = JSON.parse(localStorage.getItem("configuration"));

class Configuration {

    static get serviceUrl() {
        return currentConfig.serviceUrl;
    }

    static get connectionName() {
        return currentConfig.connectionName;
    }

    static get version() {
        return currentConfig.version;
    }

    static get allowDeliveryDateEdit() {
        return currentConfig.allowDeliveryDateEdit;
    }

    /**
     * Gets a bool value that indicates if amounts should be displayed for pending
     * transactions such as sales orders that are not invoiced
     */
    static get displayPendingAmounts() {
        return false;
    }

}

export default Configuration;


